import { useEffect, useState } from "react"

import { UserRole } from "@smerf-gaming/types"
import { getGameRoles } from "../../../../actions"

export const useGameRoles = (game_id?: string | null): [UserRole[], (game_id: string) => void, boolean] => {
  const [roles, setUserRoles] = useState<UserRole[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)

  const getRolesFunc = async (game_id?: string | null) => {
    setLoading(true)
    if (game_id) {
      const allRoles = await getGameRoles(game_id)
      setUserRoles(allRoles ?? [])
    }
    setLoading(false)
  }

  useEffect(() => {
    getRolesFunc(game_id)
  }, [])

  return [roles, getRolesFunc, isLoading]
}
